export const defiAccountTypes = [
  { id: '1', label: 'Add on Business', value: 'A0' },
  { id: '2', label: 'Courtesy', value: 'B0' },
  { id: '3', label: 'New Business', value: 'C0' },
  { id: '4', label: 'Renewal', value: 'D0' },
  { id: '5', label: 'Upgrade', value: 'E0' },
];

export const defiAccountCategories = [
  { id: '1', label: 'Third Party Program', value: 'A0' },
  { id: '2', label: 'Cold Call', value: 'B0' },
  { id: '3', label: 'LinkedIn', value: 'C0' },
  { id: '4', label: 'Direct Mail', value: 'D0' },
  { id: '5', label: 'Other', value: 'E0' },
];

export const defiPageOptions = [
  { label: 'Transations', value: 'transactions' },
  { label: 'Balances', value: 'balances' },
  { label: 'Protocols', value: 'protocols' },
  { label: 'Accounts', value: 'accounts' },
];

export const exchangePageOptions = [
  { label: 'Transations', value: 'transactions' },
  { label: 'Spot Balance', value: 'spot-balance' },
  { label: 'Future Balance', value: 'margin-balance' },
  { label: 'Exchanges', value: 'exchanges' },
];
